import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteSyllabusStructrure = () => {
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const initialFormState = {
        instituteMasterId: instituteMasterId,
        instituteBoardMappingId: '',
        instituteStreamormediumMappingId: '',
        syllabusTypeMasterId: '',
        instituteGradeMasterId: '',
        instituteSubjectMasterId: [],
        publicationMasterId: '',
        instituteSyllabusStructureName: ''
    }

    const inititalSubjectEdit = {
        instituteSubjectMasterId: []
    }

    const [formData, setFormData] = useState([])
    const [syllabusData, setSyllabusData] = useState(initialFormState)
    const [syllabusList, setSyllabusList] = useState([])
    const [editId, setEditId] = useState(null)
    const [SubList, setSubList] = useState([])
    const [gradeList, setGradeList] = useState([])
    const [subjectEdit, setSubjectEdit] = useState(inititalSubjectEdit)
    const [subjectEditError, setSubjectEditError] = useState("");

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [syllabusNameSort, setSyllabusNameSort] = useState(null);
    const [boardSort, setBoardSort] = useState(null);
    const [mediumSort, setMediumSort] = useState(null);
    const [syllabusTypeSort, setSyllabusTypeSort] = useState(null);
    const [classSort, setClassSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [publicationSort, setPublicationSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["instituteSyllabusStructureName", "instituteBoardMappingDetails.boardMasterDetails.boardName", "instituteStreamormediumMappingDetails.streamOrMediumMasterDetails.streamName", "syllabusTypeMasterDetails.syllabusTypeName", "instituteGradeMasterDetails.gradeName", "instituteSyllabusStructureMasterSubjectMappingDetails.instituteSubjectMasterDetails.subjectName", "publicationMasterDetails.publicationName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getStream();
        getSubject();
        getGrade();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getSyllabusList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (syllabusData.instituteBoardMappingId !== '') {
                setSyllabusList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(syllabusList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(syllabusList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > syllabusList.length) {
            endIndex = syllabusList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(syllabusList.slice(startIndex, endIndex));
    }, [syllabusList, currPage, itemsPerPage]);

    const getSubject = async () => {
        try {
            const apiUrl = `/get-institute-subjects?instituteMasterId=${instituteMasterId}`;
            const response = await authorizedAxiosInstitute.get(apiUrl);
            setSubList(response.data.result.map((sub) => {
                return {
                    value: sub.id,
                    label: sub.subjectName
                }
            }))
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const getGrade = async () => {
        try {
            const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
            const response = await authorizedAxiosInstitute.get(apiUrl);
            setGradeList(response.data.result.map((sub) => {
                return {
                    value: sub.id,
                    label: sub.gradeName
                }
            }))
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const getStream = async () => {
        try {
            const apiUrl = `/institute-wise-board-stream?instituteId=${instituteMasterId}`;
            const response = await authorizedAxiosInstitute.get(apiUrl);
            setFormData(response.data);
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const getApiUrl = () => {
        let apiUrl = `get-institute-syllabus-structure-master?instituteMasterId=${instituteMasterId}&`;
        if (syllabusData.instituteBoardMappingId) {
            apiUrl += `instituteBoardMappingId=${syllabusData.instituteBoardMappingId}&`;
        }

        if (syllabusData.instituteStreamormediumMappingId) {
            apiUrl += `instituteStreamormediumMappingId=${syllabusData.instituteStreamormediumMappingId}&`;
        }

        if (syllabusData.syllabusTypeMasterId) {
            apiUrl += `syllabusTypeMasterId=${syllabusData.syllabusTypeMasterId}&`;
        }

        if (syllabusData.instituteGradeMasterId) {
            apiUrl += `instituteGradeMasterId=${syllabusData.instituteGradeMasterId}&`;
        }

        if (syllabusData.instituteSubjectMasterId.length !== 0) {
            apiUrl += `instituteSubjectMasterId=${syllabusData.instituteSubjectMasterId}&`;
        }

        if (syllabusData.publicationMasterId) {
            apiUrl += `publicationId=${syllabusData.publicationMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        if (syllabusData.instituteBoardMappingId !== '') {
            getSyllabusList();
        }
    }, [syllabusData.instituteBoardMappingId, syllabusData.instituteStreamormediumMappingId, syllabusData.syllabusTypeMasterId, syllabusData.instituteGradeMasterId, syllabusData.instituteSubjectMasterId, syllabusData.publicationMasterId]);

    const getSyllabusList = async () => {
        try {
            const response = await authorizedAxiosInstitute.get(getApiUrl());
            setSyllabusList(response.data.result);
        } catch (error) {
            setSyllabusList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        setSyllabusData((prevData) => {
            if (name === 'syllabusStructureName') {
                // Update the value at the specified index
                const updatedSyllabusStructureName = [...prevData.syllabusStructureName];
                updatedSyllabusStructureName[index] = value;
                return {
                    ...prevData,
                    syllabusStructureName: updatedSyllabusStructureName,
                }
            } else {
                return {
                    ...prevData,
                    [name]: value,
                }
            }
        })
    }

    const handleChangeBoard = (selectedOptions) => {
        const selectedIds = selectedOptions?.map((option) => option.value.toString());
        setSyllabusData((prevData) => {
            return {
                ...prevData,
                instituteSubjectMasterId: selectedIds,
            }
        })
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(syllabusData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(syllabusData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [syllabusData])

    const addSyllabusType = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-institute-syllabus-structure-master`;
                const response = await authorizedAxiosInstitute.post(apiUrl, syllabusData);
                await getSyllabusList();
                setSyllabusData((prevData) => {
                    return {
                        ...prevData,
                        instituteSyllabusStructureName: '',
                    }
                })
                setSaveId(response.data.result[0].id);
                setSyllabusNameSort(null);
                setBoardSort(null);
                setMediumSort(null);
                setSyllabusTypeSort(null);
                setClassSort(null);
                setSubjectSort(null);
                setPublicationSort(null);
                setSearchValue(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(syllabusData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteSyllabus = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-syllabus-structure-master?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, syllabusList.length);
                await getSyllabusList();
                setCurrPage(page);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateSyllabus = async () => {
        if (subjectEdit.instituteSubjectMasterId.length !== 0) {
            try {
                setLoading(true);
                const apiUrl = `/edit-institute-syllabus-structure-master?id=${editId}`;
                await authorizedAxiosInstitute.put(apiUrl, subjectEdit);
                await getSyllabusList();
                setSyllabusData((prevData) => {
                    return {
                        ...prevData,
                        instituteSyllabusStructureName: '',
                    }
                })
                setSubjectEditError("");
                setSubjectEdit(inititalSubjectEdit);
                setEditId(null);
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            setSubjectEditError("This field is required.");
        }
    }

    useEffect(() => {
        if (subjectEdit.instituteSubjectMasterId.length !== 0) {
            setSubjectEditError("");
        }
    }, [subjectEdit])

    function arraysHaveCommonValues(array1, array2) {
        let commonValuesFound = false;
        for (const value of array1) {
            if (array2.includes(value)) {
                commonValuesFound = true;
                break;
            }
        }
        return commonValuesFound;
    }

    const handleChangeEdit = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        !arraysHaveCommonValues(selectedIds, syllabusData.instituteSubjectMasterId) && setSubjectEdit((prevData) => {
            return {
                ...prevData,
                instituteSubjectMasterId: selectedIds,
            }
        })
    }

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            background: syllabusData.instituteSubjectMasterId.includes(state.value.toString()) ? 'lightpink' : 'white',
        }),
    }

    const handleInputReset = () => {
        setSubjectEditError("");
        setError(initialErrorState);
        setSyllabusList([]);
        setEditId(null);
        setSyllabusData(initialFormState)
        setSubjectEdit(inititalSubjectEdit)
    }

    useEffect(() => {
        if (syllabusNameSort == true || syllabusNameSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setSyllabusTypeSort(null);
            setClassSort(null);
            setSubjectSort(null);
            setPublicationSort(null);
        }
    }, [syllabusNameSort])

    useEffect(() => {
        if (boardSort == true || boardSort == false) {
            setSyllabusNameSort(null);
            setMediumSort(null);
            setSyllabusTypeSort(null);
            setClassSort(null);
            setSubjectSort(null);
            setPublicationSort(null);
        }
    }, [boardSort])

    useEffect(() => {
        if (mediumSort == true || mediumSort == false) {
            setSyllabusNameSort(null);
            setBoardSort(null);
            setSyllabusTypeSort(null);
            setClassSort(null);
            setSubjectSort(null);
            setPublicationSort(null);
        }
    }, [mediumSort])

    useEffect(() => {
        if (syllabusTypeSort == true || syllabusTypeSort == false) {
            setSyllabusNameSort(null);
            setBoardSort(null);
            setMediumSort(null);
            setClassSort(null);
            setSubjectSort(null);
            setPublicationSort(null);
        }
    }, [syllabusTypeSort])

    useEffect(() => {
        if (classSort == true || classSort == false) {
            setSyllabusNameSort(null);
            setBoardSort(null);
            setMediumSort(null);
            setSyllabusTypeSort(null);
            setSubjectSort(null);
            setPublicationSort(null);
        }
    }, [classSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusNameSort(null);
            setBoardSort(null);
            setMediumSort(null);
            setSyllabusTypeSort(null);
            setClassSort(null);
            setPublicationSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (publicationSort == true || publicationSort == false) {
            setSyllabusNameSort(null);
            setBoardSort(null);
            setMediumSort(null);
            setSyllabusTypeSort(null);
            setClassSort(null);
            setSubjectSort(null);
        }
    }, [publicationSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item home" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Institute Syllabus Structure </span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-sitemap"></i> Institute Syllabus Structure </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Board :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='instituteBoardMappingId' onChange={handleInputChange} value={syllabusData.instituteBoardMappingId}>
                                                        <option selected value={''} disabled>Select Board</option>
                                                        {
                                                            formData?.boards?.map((board) => {
                                                                return <option value={board.id}>{board.boardMasterDetails.boardName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteBoardMappingId && <p style={{ color: 'red' }}>{error.instituteBoardMappingId}</p>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Medium :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='instituteStreamormediumMappingId' onChange={handleInputChange} value={syllabusData.instituteStreamormediumMappingId}>
                                                        <option selected value={''} disabled>Select Medium</option>
                                                        {
                                                            formData?.streams?.map((stream) => {
                                                                return <option value={stream.id}>{stream.streamOrMediumMasterDetails.streamName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteStreamormediumMappingId && <p style={{ color: 'red' }}>{error.instituteStreamormediumMappingId}</p>}
                                                </div>

                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Syllabus Type :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='syllabusTypeMasterId' onChange={handleInputChange} value={syllabusData.syllabusTypeMasterId}>
                                                        <option selected value={''} disabled>Select Type</option>
                                                        {
                                                            formData?.syllabusTypes?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.syllabusTypeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.syllabusTypeMasterId && <p style={{ color: 'red' }}>{error.syllabusTypeMasterId}</p>}
                                                </div>

                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='instituteGradeMasterId' onChange={handleInputChange} value={syllabusData.instituteGradeMasterId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList.map((grade) => {
                                                                return <option value={grade.value}>{grade.label}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteGradeMasterId && <p style={{ color: 'red' }}>{error.instituteGradeMasterId}</p>}
                                                </div>

                                                {editId ?
                                                    <div className="col-md-4">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject Edit : {syllabusData.instituteSubjectMasterId.length} selected</label>
                                                        <Select
                                                            value={SubList.filter(option =>
                                                                subjectEdit.instituteSubjectMasterId && subjectEdit.instituteSubjectMasterId.includes(option.value.toString())
                                                            )}
                                                            isMulti
                                                            name="subjectMasterId"
                                                            options={SubList}
                                                            className="basic-multi-select"
                                                            classNamePrefix="Select Board"
                                                            onChange={handleChangeEdit}
                                                            styles={customStyles}

                                                        />
                                                        {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                        {editId && subjectEditError.length !== 0 && <p style={{ color: 'red' }}>{subjectEditError}</p>}
                                                    </div>
                                                    :
                                                    <div className="col-md-4">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                        <Select
                                                            value={SubList.filter(option =>
                                                                syllabusData.instituteSubjectMasterId && syllabusData.instituteSubjectMasterId.includes(option.value.toString())
                                                            )}
                                                            isMulti
                                                            name="instituteSubjectMasterId"
                                                            options={SubList}
                                                            className="basic-multi-select"
                                                            classNamePrefix="Select Board"
                                                            onChange={handleChangeBoard}
                                                        />
                                                        {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                    </div>}

                                                <div className="col-md-4">
                                                    <label for="inputPassword" disabled={editId} className="col-form-label"><span style={{ color: "red" }}>*</span>Select Publication :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='publicationMasterId' onChange={handleInputChange} value={syllabusData.publicationMasterId}>
                                                        <option selected value={''} disabled>Select Publication</option>
                                                        {
                                                            formData?.publications?.map((publication) => {
                                                                return <option value={publication.id}>{publication.publicationName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.publicationMasterId && <p style={{ color: 'red' }}>{error.publicationMasterId}</p>}

                                                </div>
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Syllabus Name :</label>
                                                    <input type="text" disabled={editId} className="form-control" id={`instituteSyllabusStructureName`} name='instituteSyllabusStructureName' onChange={handleInputChange} value={syllabusData.instituteSyllabusStructureName} />
                                                    {error.instituteSyllabusStructureName && <p style={{ color: 'red' }}>{error.instituteSyllabusStructureName}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addSyllabusType}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleInputReset}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSyllabus} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Name
                                                                            <SortIcon sortState={syllabusNameSort} setSortState={setSyllabusNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"instituteSyllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Board
                                                                            <SortIcon sortState={boardSort} setSortState={setBoardSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"instituteBoardMappingDetails.boardMasterDetails.boardName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Medium
                                                                            <SortIcon sortState={mediumSort} setSortState={setMediumSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"instituteStreamormediumMappingDetails.streamOrMediumMasterDetails.streamName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Syllabus Type
                                                                            <SortIcon sortState={syllabusTypeSort} setSortState={setSyllabusTypeSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"syllabusTypeMasterDetails.syllabusTypeName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Class Name
                                                                            <SortIcon sortState={classSort} setSortState={setClassSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"instituteGradeMasterDetails.gradeName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={classSort} setSortState={setClassSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"instituteSyllabusStructureMasterSubjectMappingDetails.instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Publication Name
                                                                            <SortIcon sortState={publicationSort} setSortState={setPublicationSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"publicationMasterDetails.publicationName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData.map((syllabus, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{syllabus.instituteSyllabusStructureName}</td>
                                                                                        <td>{syllabus.instituteBoardMappingDetails?.boardMasterDetails.boardName}</td>
                                                                                        <td>{syllabus.instituteStreamormediumMappingDetails?.streamOrMediumMasterDetails.streamName}</td>
                                                                                        <td>{syllabus.syllabusTypeMasterDetails?.syllabusTypeName}</td>
                                                                                        <td>{syllabus.instituteGradeMasterDetails?.gradeName}</td>
                                                                                        <td>{syllabus.instituteSyllabusStructureMasterSubjectMappingDetails.map((i) => `${i.instituteSubjectMasterDetails.subjectName}, `)}</td>
                                                                                        <td>{syllabus.publicationMasterDetails?.publicationName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setSyllabusData({
                                                                                                    instituteMasterId: instituteMasterId,
                                                                                                    instituteBoardMappingId: syllabus.instituteBoardMappingDetails?.id,
                                                                                                    instituteStreamormediumMappingId: syllabus.instituteStreamormediumMappingDetails?.id,
                                                                                                    syllabusTypeMasterId: syllabus.syllabusTypeMasterDetails?.id,
                                                                                                    instituteGradeMasterId: syllabus.instituteGradeMasterDetails?.id,
                                                                                                    instituteSubjectMasterId: syllabus.instituteSyllabusStructureMasterSubjectMappingDetails?.map((i) => i.instituteSubjectMasterDetails.id.toString()),
                                                                                                    publicationMasterId: syllabus.publicationMasterDetails?.id,
                                                                                                    instituteSyllabusStructureName: syllabus.instituteSyllabusStructureName
                                                                                                });
                                                                                                setEditId(syllabus.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn-outline-danger delete_icon" title='Coming Soon...' disabled type="button" onClick={() => deleteSyllabus(syllabus.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Syllabus Structure Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={syllabusList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteSyllabusStructrure;